import { useEffect, useState } from "react";

export default function ReactivateAccountModal({
  doctorName,
  error,
  isSubmitting,
  onClose,
  onSubmit,
}) {
  const [station, setStation] = useState("");

  useEffect(() => {
    setStation("");
  }, [doctorName]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const normalizedStation = station.trim();
    if (!normalizedStation) return;
    onSubmit(normalizedStation);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="reactivate-account-title"
    >
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-lg rounded-lg bg-white p-6"
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2
              id="reactivate-account-title"
              className="text-xl font-semibold text-gray-900"
            >
              Reactivate Account
            </h2>
            <p className="mt-1 text-sm text-gray-600">
              Enter the VA station for {doctorName || "this provider"}.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            className="text-2xl leading-none text-gray-500 hover:text-gray-800 disabled:opacity-50"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <label
          htmlFor="reactivation-station"
          className="mt-6 block text-sm font-medium text-gray-700"
        >
          Station code
        </label>
        <input
          id="reactivation-station"
          type="text"
          value={station}
          onChange={(event) => setStation(event.target.value)}
          placeholder="Example: 652GB or 652"
          maxLength={20}
          autoFocus
          disabled={isSubmitting}
          className="mt-2 w-full rounded-md border border-gray-300 px-3 py-2 uppercase focus:border-transparent focus:outline-none focus:ring-2 focus:ring-ktx-purple disabled:bg-gray-100"
        />
        <p className="mt-2 text-xs text-gray-500">
          The full station code is checked first. If it is unsupported, the
          first three digits are checked.
        </p>

        {error && <p className="mt-4 text-sm text-red-600">{error}</p>}

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            className="rounded-md border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={!station.trim() || isSubmitting}
            className="rounded-md bg-ktx-purple px-4 py-2 font-medium text-white hover:bg-ktx-navy disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isSubmitting ? "Reactivating…" : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
}
